<template>
  <PanelRow class="apptoken-company-info">
    <Panel>
      <template v-if="formReady && apptoken">
        <VueForm
          :disabled="!isValid"
          :options=formOptions
          :schema=schema
          :model=item
          tag="div"
          class="flex-form grid fourth holder"
          @validated=validated
        />


        <nav class="center controls">
          <label><b>Active Plan:</b></label>
          <select class="custom-select" @change="changePlan($event)">
              <option v-for="billingsplans_ in billingsplans" :key="billingsplans_.id" :selected="billingsplans_.id == useractiveplan.billings_plans_id" :value="billingsplans_.id">{{billingsplans_.name}}</option>
          </select>

          <button type="button" class="btn xl" @click="suspend">
            {{ 'Suspend Account' | trans }}
          </button>
          <button type="button" class="btn xl" @click="activate">
            {{ 'Activate Account' | trans }}
          </button>
        </nav>
        <Loading v-if="loading" class="absolute" />
      </template>
      <Loading v-else />
    </Panel>
  </PanelRow>
</template>

<script>
  import form from '@/helpers/mixins/form'
  import {apptokens as fields} from '../apptokens/fields'
  import _ from 'lodash'
  import Vue from 'vue';
  import VueAlertify from 'vue-alertify';
  import JsonCSV from 'vue-json-csv';

  Vue.use(VueAlertify, {
    notifier: {
      delay: 3,
      position: 'top-right',
      closeButton: false,
    },
  });
  Vue.component('downloadCsv', JsonCSV);

  var keys = [
    'image', 'is_company', 'company_name', 'company_contact_email', 'company_description',
    'company_phone', 'company_website',
    'company_registered_address', 'company_registered_city', 'company_registered_zip', 'company_registered_countries_id',
    'company_billing_address', 'company_billing_city', 'company_billing_zip', 'company_billing_countries_id',
    'company_vat',
  ];

  export default {
    name: 'CompanyProfile',
    mixins: [form],
    data() {return {
      loading: false,
      reload: 0,
      item: {},
      billingsplans: [],
      useractiveplan: [],
      protofields: _.pick(fields, keys),
    }},
    asyncComputed: {
      apptoken: {
        get () {
          this.apptoken = false;
          return this.async(['apptoken', 'user']).then(([token, user]) => {
            var id;
            if (this.$store.getters.admin) {
              id = token.id;
            } else {
              id = 'me';
            }
            return this.api.get('apptokens/' + this.$route.params.id + '?include=images');
          });
        },
        watch () {
          this.reload;
        },
      },
    },
    methods: {
      submit () {
        if (!this.isValid) {return;}
        this.loading = true;
        var data = _.pickBy(_.clone(this.nonImageValues), a=>a);
        this.api.put('apptokens/' + this.apptoken.id, data)
          .toast(false)
          .then(() => this.applyImages('apptokens', this.apptoken.id, this.item))
          .then(() => this.reload++)
          .finally(() => this.loading = false)
        ;
      },
      setItem () {
        if (this.apptoken) {
          this.item = _.pick(this.apptoken.data[0], Object.keys(this.protofields));
          this.item.images = this.apptoken.images;
        } else {
          this.item = {};
        }
      },
      suspend () {
        this.api.post('/sso/aquest/master/suspendaccount',{ "apptokens_id": this.$route.params.id }, {
            "app-token": "6e837457fd14dd0a05d8",
        })
        .then((response) => {
            if(response.status == 200) {
              this.$alertify.success(response.message);
            }
            else {
              this.$alertify.error(error);
            }
        })
        .catch((error) => {
            this.$alertify.error(error);
            console.log(error);
        })
      },
      activate () {
        this.api.post('/sso/aquest/master/activateaccount',{ "apptokens_id": this.$route.params.id }, {
            "app-token": "6e837457fd14dd0a05d8",
        })
        .then((response) => {
            if(response.status == 200) {
              this.$alertify.success(response.message);
            }
            else {
              this.$alertify.error(error);
            }
        })
        .catch((error) => {
            this.$alertify.error(error);
            console.log(error);
        })
      },
      changePlan(event) {
        this.api.post('/sso/aquest/master/changeplanbyadmin',{ 
            "apptokens_id": this.$route.params.id ,
            "plan_id": event.target.value
          }, 
          {
            "app-token": "6e837457fd14dd0a05d8",
        })
        .then((response) => {
            if(response.status == 200) {
              this.$alertify.success(response.message);
            }
            else {
              this.$alertify.error(error);
            }
        })
        .catch((error) => {
            this.$alertify.error(error);
            console.log(error);
        })
      }
    },
    watch: {
      apptoken () {this.setItem();}
    },
    mounted () {
        this.setItem();
        setTimeout(function(){
            document.getElementById("company-name").readOnly = true;
            document.getElementById("company-contact-email").readOnly = true;
            document.getElementById("company-description").disabled = true;
            document.getElementById("company-phone").readOnly = true;
            document.getElementById("company-website").readOnly = true;
            document.getElementById("company-address").readOnly = true;
            document.getElementById("company-city").readOnly = true;
            document.getElementById("company-zip").readOnly = true;
            document.getElementById("company-country").disabled = true;
            document.getElementById("company-billing-address").readOnly = true;
            document.getElementById("company-billing-city").readOnly = true;
            document.getElementById("company-billing-zip").readOnly = true;
            document.getElementById("company-billing-country").disabled = true;
            document.getElementById("company-vat").disabled = true;
            document.getElementById("account-type").disabled = true;
            document.getElementsByTagName("button").disabled = true;
        }, 3500);

        this.api.post('/sso/aquest/master/getbillingsplans',{}, {
            "app-token": "6e837457fd14dd0a05d8",
        })
        .then((response) => {
            this.billingsplans = response.data;
        })
        .catch((error) => {
            console.log(error);
        })

        this.api.post('/sso/aquest/master/getuseractiveplan',{  "apptokens_id": this.$route.params.id }, {
            "app-token": "6e837457fd14dd0a05d8",
        })
        .then((response) => {
            if(response.status == 200) {
              this.useractiveplan = response.data[0];
            }
            else {
              console.log(error);
            }
        })
        .catch((error) => {
            console.log(error);
        })

    },
  }
</script>

<style lang="scss">
  .apptoken-company-info {
    nav.controls {
      margin-top: 30px;
    }
    @media (min-width: $xs-min) {
      .flex-form {
        > div {
          > .field-imageselect {
            grid-row-end: span 3;
            @media (min-width: $sm-min) {
              grid-row-end: span 4;
            }
            > .field-wrap {
              padding-top: 29px;
            }
          }
          > .field-company_description {
            @media (min-width: $xs-min) {
              //grid-row-end: span 2;
            }
            @media (min-width: $md-min) {
              grid-column-end: span 2;
            }
          }
          > .field-company_registered_countries_id {
            padding-bottom: 80px;
          }
          > .field-company_billing_address {
            grid-column-start: 1;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/general/CompanyProfile.vue